<template>
  <el-dialog
    title="合同详情"
    :visible.sync="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    @close="handleClose">

    <div style="max-height: 600px;overflow-y: auto;" v-loading="loading">
      <el-form :model="contractData" label-width="100px" size="mini" style="margin-right: 50px;">

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="合同类型">
              <el-tag :type="contractData.contract_type === 1 ? 'success' : 'warning'">
                {{ contractData.contract_type === 1 ? '战略合同' : '预合同' }}
              </el-tag>
            </el-form-item>

            <el-form-item label="业务类型">
              <span>{{ contractData.entry_type_name }}</span>
            </el-form-item>

            <el-form-item label="组织架构">
              <span>{{ contractData.contract_area }}</span>
            </el-form-item>

            <el-form-item label="合同项目">
              <span>{{ projectInfo.name || '-' }}</span>
            </el-form-item>

            <el-form-item label="合同名称">
              <span>{{ contractData.name }}</span>
            </el-form-item>

            <el-form-item label="合同编号">
              <span>{{ getContractNumber() }}</span>
            </el-form-item>

            <el-form-item label="签订时间">
              <span>{{ contractData.signing_time || '-' }}</span>
            </el-form-item>

            <el-form-item label="进场时间">
              <span>{{ contractData.mobilization_time || '-' }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所在板块">
              <span>{{ contractData.contract_business || '-' }}</span>
            </el-form-item>

            <el-form-item label="合同总价">
              <span style="color: #409EFF; font-weight: bold;">{{ formatMoney(contractData.contract_price) }}</span>
            </el-form-item>

            <el-form-item label="履约保证金">
              <span>{{ formatMoney(contractData.performance_bond) }}</span>
            </el-form-item>

            <el-form-item label="合同人数">
              <span>{{ contractData.contract_personnel_number || 0 }} 人</span>
            </el-form-item>

            <el-form-item label="服务面积">
              <span>{{ contractData.service_area || '-' }}</span>
            </el-form-item>

            <el-form-item label="付款周期">
              <span>{{ contractData.payment_method || '-' }}</span>
            </el-form-item>

            <el-form-item label="合同负责人">
              <span>{{ contractData.contract_leader || '-' }}</span>
            </el-form-item>

            <el-form-item label="撤场时间">
              <span>{{ contractData.demobilization_time || '-' }}</span>
            </el-form-item>

            <el-form-item label="到期情况">
              <span>{{ contractData.end_detail || '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="甲方">
              <span>{{ contractData.party_a }}</span>
            </el-form-item>

            <el-form-item label="甲方简称">
              <span>{{ contractData.party_a_abbreviation || '-' }}</span>
            </el-form-item>

            <el-form-item label="甲方联系人">
              <span>{{ contractData.party_a_people || '-' }}</span>
            </el-form-item>

            <el-form-item label="甲方联系方式">
              <span>{{ contractData.party_a_tell || '-' }}</span>
            </el-form-item>

            <el-form-item label="甲方联系地址">
              <span>{{ contractData.party_a_address || '-' }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="乙方">
              <span>{{ contractData.party_b }}</span>
            </el-form-item>

            <el-form-item label="乙方简称">
              <span>{{ contractData.party_b_abbreviation || '-' }}</span>
            </el-form-item>

            <el-form-item label="乙方联系人">
              <span>{{ contractData.party_b_people || '-' }}</span>
            </el-form-item>

            <el-form-item label="乙方联系方式">
              <span>{{ contractData.party_b_tell || '-' }}</span>
            </el-form-item>

            <el-form-item label="乙方联系地址">
              <span>{{ contractData.party_b_address || '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-form-item label="开票类目">
          <span>{{ contractData.tax_code || '-' }}</span>
        </el-form-item>

        <el-form-item label="税率">
          <span>{{ contractData.tax_rate ? contractData.tax_rate + '%' : '-' }}</span>
        </el-form-item>

        <el-form-item label="开票服务名称">
          <span>{{ contractData.tax_name || '-' }}</span>
        </el-form-item>

        <el-divider></el-divider>

        <el-form-item label="合同起始">
          <span>{{ contractData.charging_start_end || '-' }}</span>
          <span style="margin-left: 10px;" v-if="monthMoneyList.length > 0">共 {{ monthMoneyList.length }} 个月</span>
        </el-form-item>

        <el-form-item label="款项周期">
          <span>{{ contractData.payment_cycle || '-' }} 个月</span>
        </el-form-item>

        <el-form-item label="月金额明细">
          <el-table
            :data="monthMoneyList"
            height="250"
            border
            style="width: 100%">
            <el-table-column prop="month" label="月份" align="center" width="150"></el-table-column>
            <el-table-column prop="money" label="金额" align="center">
              <template slot-scope="scope">
                <span>{{ formatMoney(scope.row.money) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 10px; color: #606266;">
            合同总价：{{ formatMoney(contractData.contract_price) }} &nbsp;&nbsp;&nbsp;
            月合计金额：{{ formatMoney(allMonthAmount) }} &nbsp;&nbsp;&nbsp;
            浮动：{{ (contractData.contract_price - allMonthAmount).toFixed(2) }}
          </div>
        </el-form-item>

        <el-form-item label="备注">
          <span>{{ contractData.remarks || '-' }}</span>
        </el-form-item>

        <el-form-item label="是否续签">
          <el-tag :type="contractData.is_renewal ? 'success' : 'info'">
            {{ contractData.is_renewal ? '是' : '否' }}
          </el-tag>
        </el-form-item>

        <el-form-item label="是否过期">
          <el-tag :type="contractData.is_end ? 'danger' : 'success'">
            {{ contractData.is_end ? '是' : '否' }}
          </el-tag>
        </el-form-item>

        <el-form-item label="合同状态">
          <el-tag :type="getContractStatusType()">
            {{ getContractStatusText() }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CommonHelp from "../common/CommonHelp";

export default {
  name: "ContractDetailDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      contractData: {},
      projectInfo: {},
      monthMoneyList: []
    };
  },
  computed: {
    allMonthAmount() {
      return this.monthMoneyList.reduce((sum, item) => {
        return sum + (parseFloat(item.money) || 0);
      }, 0);
    }
  },
  methods: {
    open(contractId) {
      if (!contractId) {
        this.$message.error('合同ID不能为空');
        return;
      }
      this.dialogVisible = true;
      this.loadContractDetail(contractId);
    },

    loadContractDetail(contractId) {
      this.loading = true;
      CommonHelp.post("Contract/getContract", { id: contractId }, res => {
        this.loading = false;
        if (res.code === 1) {
          this.contractData = res.data;
          if (this.contractData.month_money_list) {
            try {
              this.monthMoneyList = typeof this.contractData.month_money_list === 'string'
                ? JSON.parse(this.contractData.month_money_list)
                : this.contractData.month_money_list;
            } catch (e) {
              this.monthMoneyList = [];
            }
          }
          if (this.contractData.project_id) {
            this.loadProjectInfo(this.contractData.project_id);
          }
        } else {
          this.$message.error(res.msg || '获取合同详情失败');
        }
      });
    },

    loadProjectInfo(projectId) {
      CommonHelp.get("Project/get", { id: projectId }, res => {
        if (res.code === 1) {
          this.projectInfo = res.data;
        }
      });
    },

    formatMoney(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return '0.00';
      }
      const num = Number(amount);
      if (isNaN(num)) {
        return '0.00';
      }
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getContractNumber() {
      return `${this.contractData.number_code || ''}${this.contractData.number_str || ''}${this.contractData.number_ext || ''}`;
    },

    getContractStatusText() {
      if (this.contractData.is_stop === 1) return '已终止';
      if (this.contractData.is_end === 1) return '已过期';
      if (this.contractData.status === 1) return '执行中';
      if (this.contractData.to_status > 0) return '审核中';
      return '草稿';
    },

    getContractStatusType() {
      if (this.contractData.is_stop === 1) return 'info';
      if (this.contractData.is_end === 1) return 'danger';
      if (this.contractData.status === 1) return 'success';
      if (this.contractData.to_status > 0) return 'warning';
      return 'info';
    },

    handleClose() {
      this.contractData = {};
      this.projectInfo = {};
      this.monthMoneyList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/ContractDetailDialog.vue